import { IDynamicDiplayView } from '@components/widgets/dynamic-display';

import { GetPolicyDetails } from '../types';

export const buildPaymentDivisionView = (
  data: GetPolicyDetails
): IDynamicDiplayView => ({
  name: 'Payment Division Details',
  isCollapsible: true,
  sections: [
    {
      name: 'paymentDivisionDetails',
      title: 'Payment Division Details',
      showActionButtons: false,
      properties: {
        PaymentFrequency: {
          multiline: false,
          value: data?.paymentDivisionFrequency?.title ?? '',
          name: 'PaymentFrequency',
          title: 'Payment Frequency'
        },
        PaymentTotalNumber: {
          multiline: false,
          value: data?.paymentDivisionTotalNumber?.toString() ?? '0',
          name: 'PaymentTotalNumber',
          title: 'Payment Total Number'
        },
        PaymentNumberReached: {
          multiline: false,
          value: data?.paymentDivisionNumberReached?.toString() ?? '0',
          name: 'PaymentNumberReached',
          title: 'Payment Number Reached'
        }
      }
    }
  ]
});
